<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tb4t1Q/images/cover.jpg?1712278213255" alt="This image is the cover for the book Tales from the Big House: Temple Newsam"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tales from the Big House: Temple Newsam
      </h1>
      <p class="bookDescription body article font2">
        <p>Situated only 4 miles southeast of the bustling cosmopolitan city of Leeds lies a jewel in the crown of British stately homes. Set in 1,200 acres of rolling parkland and woods is Temple Newsam House, once described as the Hampton Court of the North.The estate has survived almost 900 years of history. Although first mentioned in the Domesday Book, it was the Knights Templar who gave the name to the land. The house that now stands on the site was begun in 1518 and has witnessed many events: the execution for treason of one of its owners; the birth of Lord Darnley, unlucky husband of Mary Queen of Scots; the Civil War rivalry of a family; the home of a flirtatious mistress of the Prince of Wales (later George IV); and the suffering of the First World War, when it was used as a convalescent home for wounded soldiers.The house and estate is now owned by the Leeds City Council and is open as a public park for all to enjoy. The house itself is part of Leeds Museums and Galleries and displays many different collections and exhibitions. On the estate is a working farm, known as Home Farm, which is the largest working rare breed center in the UK and is a popular attraction for many visitors.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Ward
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00c8288c